import { useFetchData } from "./query";
import orderService from "../redux/order-management/order-management-service";

export default function useOrders(queryParams) {
  const { data: orderList, isLoading: orderListIsLoading } = useFetchData(
    ["orders-list", queryParams],
    () => orderService.getOrdersList(queryParams)
  );
  const { data: adminAccountDetails } = useFetchData(
    ["admin-account-details"],
    () => orderService.getAdminAccountDetails()
  );
  async function partialOrderDecline(orderId) {
    try {
      const response = await orderService.getFullCredit(orderId);
      return response;
    } catch (error) {
      console.error("Something went wrong");
    }
  }
  async function partialOrderAccept(payload) {
    try {
      const response = await orderService.modifyOrder(payload);
      return response;
    } catch (error) {
      console.error("Something went wrong");
    }
  }
  async function requestPaymentRefund(payload) {
    try {
      const response = await orderService.requestRefund(payload);
      return response;
    } catch (error) {
      console.error("Something went wrong");
    }
  }
  return {
    listOfOrders: orderList,
    orderListIsLoading,
    adminAccountDetails,
    partialOrderDecline,
    partialOrderAccept,
    requestPaymentRefund,
  };
}
